import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { SuiDropdownDirective, SuiTooltipDirective } from '@semeris/ui';

import { UserTenantOption } from '../../../settings/models/user-profile.model';

/** Shows the tenant the user is in; when there is another one to go to, it also switches. */
@Component({
  selector: 'semeris-tenant-switcher',
  imports: [SuiDropdownDirective, SuiTooltipDirective],
  templateUrl: './tenant-switcher.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TenantSwitcherComponent {
  public readonly activeTenant = input.required<UserTenantOption>();
  /** The tenants the user may switch between, the active one included. */
  public readonly tenants = input<UserTenantOption[]>([]);
  public readonly switchTenant = output<string>();

  public readonly canSwitch = computed(() => this.tenants().length > 1);

  public onSelect(tenant: UserTenantOption): void {
    if (tenant.tenantShortName !== this.activeTenant().tenantShortName) {
      this.switchTenant.emit(tenant.tenantShortName);
    }
  }
}
